import { Dialog } from "@ark-ui/react/dialog";
import { IconX } from "@decibeltrade/react-icons";
import { forwardRef, PropsWithChildren } from "react";
import { css, cx } from "styled-system/css";
import { flex } from "styled-system/patterns";

import { IconButton } from "../components/buttons/icon-button";

export const ModalHeader = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ onClose: () => void; className?: string; closeText?: string }>
>((props, ref) => {
  return (
    <div
      ref={ref}
      className={cx(
        flex({ align: "center", justify: "space-between", textStyle: "highlight.xl" }),
        props.className,
      )}
    >
      <Dialog.Title>{props.children}</Dialog.Title>
      <IconButton
        size="lg"
        variant="text"
        onClick={props.onClose}
        ariaLabel={props.closeText ?? "Close"}
        className={css({ m: "[-12px]" })}
      >
        <IconX />
      </IconButton>
    </div>
  );
});
ModalHeader.displayName = "ModalHeader";

export type ModalContentProps = PropsWithChildren<{ className?: string }>;

export const ModalContent = forwardRef<HTMLDivElement, ModalContentProps>((props, ref) => {
  return (
    <div
      ref={ref}
      className={cx(
        css({
          textStyle: "body.md",
          bgGradient: "modalBackground",
          color: "text.secondary",
          rounded: "300",
          borderWidth: "100",
          borderColor: "border.primary",
          p: "24",

          // Modal Sizing
          maxW: "[90vw]",
          w: "[620px]", // This value is somewhat arbitrary and can be overridden
          maxH: "[calc(100vh - 64px)]",
          overflow: "auto",
        }),
        props.className,
      )}
    >
      {props.children}
    </div>
  );
});

ModalContent.displayName = "ModalContent";
